import { Injectable } from '@angular/core';
import { GlobalRequest } from '../global/presenter/global.request';
import { GlobalPresenter } from '../global/presenter/global.presenter';
import { PdfMakeWrapper } from 'pdfmake-wrapper';
import { EmailTemplate } from '../../constants/email-template';
import { UserRolesEnum } from '../../constants/user-roles.enum';


@Injectable({
  providedIn: 'root'
})
export class SendPdfEmailService {
files_arr: File[] = [];
img_files_arr: File[] = [];

constructor(private globalPresenter: GlobalPresenter){}

sendPdfEmail(pdf:PdfMakeWrapper, emailTemplate:string, fileName:string, images:File[]): Promise<boolean> {
  this.img_files_arr = images;
  return new Promise((resolve, reject) => {
    const pdfDocGenerator = pdf.create();
    pdfDocGenerator.getBlob(async (document) => {
      var file = new File([document],`${fileName}.pdf`, {
        type: "application/pdf",
      });
      this.files_arr.push(file);
      const result = await this.setEmailData(emailTemplate);
      (result)? resolve(true) : reject(false);
    });

  });
}
private async setEmailData(emailTemplate:string): Promise<boolean> {
  const _emails: string[] = [];
  return new Promise(async (resolve, reject) => {
    const users = await this.globalPresenter.getUserList();
    if(users){
      users.forEach(user => {
        if(user.role ==  UserRolesEnum.SERVICES_ROLE){
          _emails.push(user.email);
        }
      });
      resolve(await this.sendingEmail(_emails.join(), emailTemplate));
    }else {
      reject(false);
    }
  });
}
private async sendingEmail(_emails: string, emailTemplate:string): Promise<boolean> {
  let json = {
    email: _emails,
    bodyHtml: EmailTemplate.HTML_BODY_ORDER(emailTemplate),
    attachment: _emails
  }
   return await this.globalPresenter.sentEmail(_emails, json.bodyHtml, [...this.files_arr, ...this.img_files_arr]);
}

}

